import styled from 'styled-components'
import {device} from '../../media_queries'

const MainBanner = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  background-color: #ffffff;
  @media ${device.mobileS} {

  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {
    width: 100%;
    height: 100%;
  }
  @media ${device.desktop} {
    
  }
`;
const FinalCont = styled.div`
    width: 90vw;
    height: auto;
    margin: 2%;
    background-image: url('https://res.cloudinary.com/dojodevs/image/upload/v1574746789/smartia/RECURSOS/STOCK_HAL_07_drydod.jpg');
    background-size: cover;
    background-position: center;
    color: white;
    @media ${device.mobileS} {
        height: auto;
    }

    @media ${device.tablet} {
        font-size:.7rem;
        color: white;
        height: 60vh
    }

    @media ${device.laptop} {
    font-size: 1em;
}
    @media ${device.desktop} {
  
}
`
const CircleCont = styled.div`
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    margin:2%;
    flex-direction: row;
    width:100%;
    height:auto;
    font-family:'panton-extrabold';

    @media ${device.mobileS} {

}
    @media ${device.tablet} {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    height: auto;  
}
    @media ${device.laptop} {
    font-size: 1em;
}
    @media ${device.desktop} {
        &>img{
        height: 30vh;
        width: auto;
    }  
}
`

const FinalCirc1 = styled.div`
    padding: 2%;
    margin-top: 5vh;
    &>img{
        height: 20vh;
        width: auto;
        font-family:'panton-light';

    @media ${device.mobileS} {

}
    @media ${device.tablet} {
        padding: 2%;
    &>img{
        height: 7vh;
        width: auto;
        
}
    }
    @media ${device.laptop} {
    font-size: 1em;
}
    @media ${device.desktop} {
        &>img{
        height: 35vh;
        width: auto;
    }  
}
    }

`
const FinalCirc2 = styled.div`
    padding: 2%;
    margin-top: 5vh;
    &>img{
        height: 20vh;
        width: auto;
        font-family:'panton-light';

@media ${device.mobileS} {

}
    @media ${device.tablet} {
        padding:2%;
    &>img{
        height: 7vh;
        width: auto;
}
}
    @media ${device.laptop} {
    font-size: 1em;
}
    @media ${device.desktop} {
        &>img{
        height: 35vh;
        width: auto;
    }  
  
}
    }
`
const FinalCirc3 = styled.div`
    padding: 2%;
    margin-top: 5vh;
    &>img{
        height: 20vh;
        width: auto;
        font-family:'panton-light';

    @media ${device.mobileS} {

}
    @media ${device.tablet} {
    &>img{
        height: 7vh;
        width: auto;
}
}
    @media ${device.laptop} {
    font-size: 1em;
}
    @media ${device.desktop} {
        &>img{
        height: 35vh;
        width: auto;
    } 
}
    }
`

export { MainBanner, CircleCont, FinalCont, FinalCirc1, FinalCirc2, FinalCirc3};